<template>
    <div>
        <div class="common-header">
            <div class="common-header-right">
                <div class="common-header-block">
                    申请时间：
                    <el-date-picker
                            v-model="date"
                            type="datetimerange"
                            format="yyyy-MM-dd HH:mm"
                            value-format="yyyy-MM-dd HH:mm"
                            start-placeholder="开始时间"
                            end-placeholder="结束时间"/>
                </div>
                <div class="common-header-block">
                    审核时间：
                    <el-date-picker
                            v-model="applyDate"
                            type="datetimerange"
                            format="yyyy-MM-dd HH:mm"
                            value-format="yyyy-MM-dd HH:mm"
                            start-placeholder="开始时间"
                            end-placeholder="结束时间"/>
                </div>
                <div class="common-header-block">
                    <el-input v-model="channelId" placeholder="请输入渠道ID">
                        <template slot="prepend">渠道ID</template>
                    </el-input>
                </div>
                <div class="common-header-block">
                    <el-input v-model="userRandomId" placeholder="请输入玩家ID查询">
                        <template slot="prepend">玩家ID</template>
                    </el-input>
                </div>
                <div class="common-header-block">审核状态：
                    <el-select class="common-el-select-small" v-model="reviewStatu">
                        <el-option
                                v-for="item of reviewStatuOptions"
                                :key="item.label"
                                :value="item.value"
                                :label="item.label"/>
                    </el-select>
                </div>
                <div class="common-header-block">
                    <el-button type="primary" @click="getList()">搜索</el-button>
                </div>
            </div>
        </div>

        <strong style="padding-top: 20px" v-if="permissions.osm_all_field" v-text="`总记分牌：${totalScore}`"></strong>

        <div class="common-table">
            <el-table v-loading="loading" :data="beanApplyList.beanList" height="100%" row-key="id">
                <el-table-column label="编号" type="index" align="center"/>
                <el-table-column label="提豆号" prop="id" align="center"/>
                <el-table-column label="玩家ID" width="120" prop="userRandomId" align="center"/>
                <el-table-column label="玩家昵称" width="150" align="center" prop="userNickname"/>
                <el-table-column label="渠道ID" align="center" prop="payChannelId"/>
                <el-table-column label="渠道昵称" min-width="150" align="center" prop="payChannelName"/>
                <el-table-column label="所属俱乐部名称" width="180" align="center" prop="clubName"/>
                <el-table-column label="所属子联盟昵称" width="150" align="center" prop="subTribeName"/>
                <el-table-column label="所属主联盟昵称" width="150" align="center" prop="mainTribeName"/>
                <el-table-column label="交易模式" width="120" align="center">
                    <template slot-scope="scope">
                        {{scope.row.clubTransType | topUpTypeName}}
                    </template>
                </el-table-column>
                <el-table-column label="提豆数量" align="center" prop="chip"/>
                <el-table-column label="提豆金额（元）" width="120" align="center" prop="amount"/>
                <el-table-column label="第三方查询单号" min-width="180" align="center" prop="payNo"/>
                <el-table-column label="申请时间" width="150" align="center" prop="createdTime"/>
                <el-table-column label="完结时间" width="150" align="center" prop="finishTime"/>
                <el-table-column label="审核时间" width="150" align="center" prop="applyTime"/>
                <el-table-column label="账号信息" align="center" prop="accountInfo">
                    <template slot-scope="scope">
                        <el-button size="mini" type="primary" @click="checkInfo(scope.row.id)">查看</el-button>
                    </template>
                </el-table-column>
                <el-table-column label="提豆状态" align="center">
                    <template slot-scope="scope">
                        {{scope.row.status | reviewType}}
                    </template>
                </el-table-column>
            </el-table>
        </div>

        <el-pagination
                class="common-el-pagination"
                layout="prev,pager,next,jumper"
                background
                :page-size="20"
                :pager-count="5"
                :total="beanApplyList.total"
                :current-page="currentPage"
                @current-change="getList($event)"/>
        <div v-show="centerDialogVisible" class="common-popup-bg">
            <div class="common-popup">
                <h3>账户信息</h3>
                <i class="common-popup-close el-icon-close" @click="centerDialogVisible = false"></i>
                <table class="common-popup-table">
                    <tr>
                        <td>户名：</td>
                        <td v-text="withdrawAccountInfo.bankAccName"></td>
                    </tr>
                    <tr>
                        <td>银行卡号：</td>
                        <td v-text="withdrawAccountInfo.bankAccNo"></td>
                    </tr>
                    <tr>
                        <td>银行名称：</td>
                        <td v-text="withdrawAccountInfo.bankName"></td>
                    </tr>
                    <tr>
                        <td>开户行：</td>
                        <td v-text="withdrawAccountInfo.bankOfDeposit"></td>
                    </tr>
                    <tr>
                        <td>联系方式：</td>
                        <td v-text="withdrawAccountInfo.contact"></td>
                    </tr>
                </table>
                <footer>
                    <el-button size="small" type="primary" @click="centerDialogVisible = false">关闭</el-button>
                </footer>
            </div>
        </div>
    </div>
</template>
<script>
    import {mapState, mapActions} from 'vuex'

    export default {
        data() {
            return {
                loading: false,
                reviewStatuOptions: [
                    {value: '', label: '全部'},
                    {value: '0', label: '审核中'},
                    {value: '1', label: '打款中'},
                    {value: '2', label: '提现成功'},
                    {value: '3', label: '提现失败'},
                    {value: '4', label: '已拒绝'}
                ],
                reviewStatu: '',//审核状态
                date: null,
                applyDate: null,
                currentPage: 1,
                userRandomId: '',
                channelId: '',//渠道id
                centerDialogVisible: false,
                beanApplyList: {// 提豆申请列表
                    beanList: [],
                    total: 0
                },
                totalScore: 0,// 总记分牌
            }
        },
        computed: {
            ...mapState('withdrawChip', ['withdrawAccountInfo']),
            ...mapState('login', ['permissions'])
        },
        created() {
            this.getList()
        },
        filters: {
            reviewType(type) {
                if (type === 0) {
                    return "审核中"
                } else if (type === 1) {
                    return "打款中"
                } else if (type === 2) {
                    return "提现成功"
                } else if (type === 3) {
                    return "提现失败"
                } else if (type === 4) {
                    return "已拒绝"
                }
            }
        },
        methods: {
            ...mapActions('withdrawChip', ['getWithdrawAccountInfo', 'getWithdrawTotal', 'getWithdrawList']),
            parameterCalibration() {
                if (!this.date) {
                    this.$message.error('请选择申请时间');
                    return false
                }
                return true
            },
            getList(page = 1) {
                // if(!this.parameterCalibration()) return;
                this.loading = true;
                this.currentPage = page;
                let params = {
                    payChannelId: this.channelId,
                    status: this.reviewStatu,
                    page: page,
                    startTime: this.date && this.date[0] || '',
                    endTime: this.date && this.date[1] || '',
                    applyStartTime: this.applyDate && this.applyDate[0] || '',
                    applyEndTime: this.applyDate && this.applyDate[1] || '',
                    userRandomId: this.userRandomId,
                };
                this.getWithdrawList(params).then(res => {
                    this.beanApplyList = res;
                    this.loading = false;
                });
                this.getWithdrawTotal(params).then(res => {
                    this.totalScore = res.totalScore;
                })
            },
            //查看账户信息
            checkInfo(id) {
                this.getWithdrawAccountInfo({
                    withdrawChipId: id
                }).then(() => {
                    this.centerDialogVisible = true;
                })
            },
        }
    }
</script>
